import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree,} from "@angular/router";
import {AuthService} from "../services/auth.service";
import {JwtHelperService} from "@auth0/angular-jwt";
import {LocationsService} from "../services/locations.service";
import {SettingsService} from "../services/settings.service";
import {FreeSubscriptionGuard} from "./free-subscription.guard";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class UserGuard implements CanActivate {
  jwtHelper;

  constructor(
    private router: Router,
    private locationService: LocationsService,
    private settingsService: SettingsService
  ) {
    this.jwtHelper = new JwtHelperService();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean | UrlTree> {
    const localToken = AuthService.getOauthTokenFromStorage();
    if(!localToken) return this.refuse();
    const token = this.jwtHelper.decodeToken(localToken);
    if (!token.roles) return this.refuse();
    if (!token.roles.includes("User")) return false;

    return FreeSubscriptionGuard.isFreeSubscription(this.settingsService).pipe(
      map((isFreeSubscription) =>
        isFreeSubscription ? this.router.createUrlTree(["/free-subscription"]) : true,
      ),
    );
  }

  refuse(): boolean {
    this.router.navigate(["/login"]);
    return false;
  }
}
